import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from "react-bootstrap";

function Login() {
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.onloadedmetadata = () => {
                    videoRef.current.play();
                };
            }
        } catch (err) {
            console.error('Error accessing camera:', err);
            alert('Unable to access camera');
        }
    };

    const stopCamera = () => {
        if (videoRef.current && videoRef.current.srcObject) {
            const tracks = videoRef.current.srcObject.getTracks();
            tracks.forEach((track) => track.stop());
            videoRef.current.srcObject = null;
        }
    };

    const drawYellowArea = () => {
        if (canvasRef.current && videoRef.current) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            // Set canvas dimensions to match video
            canvas.width = videoRef.current.videoWidth;
            canvas.height = videoRef.current.videoHeight;
            // Clear canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            // Draw yellow rectangle (centered area)
            const rectWidth = 400; // Width of the rectangle
            const rectHeight = 350; // Height of the rectangle
            const rectX = (canvas.width - rectWidth) / 2; // X-coordinate (centered)
            const rectY = (canvas.height - rectHeight) / 2; // Y-coordinate (centered)
            ctx.strokeStyle = 'yellow';
            ctx.lineWidth = 2;
            ctx.strokeRect(rectX, rectY, rectWidth, rectHeight);
        }
    };

    useEffect(() => {
        startCamera();
        return () => {
            stopCamera();
        };
    }, []);

    useEffect(() => {
     
            const interval = setInterval(drawYellowArea, 400);
            return () => clearInterval(interval);
     
    });

    const handleLogin = (e) => {
        e.preventDefault();
        if (password === '123') {
            stopCamera();
            navigate('/dashboard');
        } else {
            alert('Invalid NIP or password');
        }
    };

    return (
        <div className="loginstyle">
            <Card style={{ width: '28rem' }}>
                <Card className="border-0">
                    <Card.Body className="d-flex justify-content-between">
                        <h5>Face Recognition Authentication</h5>
                        <img
                            alt="Logo"
                            src="https://www-api.bkkbn.go.id/storage/app/logo/40847d55-9175-45c1-92f8-ce10cbb0cb7c/e6b841d9-9fee-48f0-b6bf-b2370cd016de.png"
                            style={{ width: 145, height: 70 }}
                        />
                    </Card.Body>
                </Card>
                <Card.Body>
                    <div className="position-relative">
                        <video
                            ref={videoRef}
                            style={{ width: '100%', height: '311px', backgroundColor: 'black' }}
                            autoPlay
                            muted
                        />
                        <canvas
                            ref={canvasRef}
                            className="position-absolute top-0 start-0"
                            style={{ width: '100%', height: '311px', pointerEvents: 'none' }}
                        />
                    </div>
                    <Card.Text>
                        <form onSubmit={handleLogin}>
                            <div className="form-group">
                                <label>NIP</label>
                                <input
                                    type="text"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your NIP"
                                    required
                                    className="form-control"
                                />
                            </div>
                            <Button
                                variant="warning"
                                className="w-100 mt-3"
                                type="submit"
                            >
                                Masuk dengan wajah
                            </Button>
                        </form>
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    );
}

export default Login;
